import { Box, Card, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import React, { useEffect, useState } from 'react'
import { ApiGetCategories, ApiGetColors, ApiGetSizes } from '../../../../Core/Apicall';
import { toast } from 'react-toastify';
import { Color } from '../../../../types/Color';
import { Category } from '../../../../types/Category';
import { Size } from '../../../../types/Size';
interface Props {
  formik: FormikProps<any>;
}
function ProductReview({ formik }: Props) {
  const [categoryList, setCategoryList] = useState<Category[]>([])
  const [colorlist, setColorList] = useState<Color[]>([])
  const [sizelist, setSizeList] = useState<Size[]>([])

  const getCategoryList = async () => {
    try {
      const res = await ApiGetCategories()
      if (res?.status) {
        setCategoryList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  const getColors = async () => {
    try {
      const res = await ApiGetColors()
      if (res?.status) {
        setColorList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  const getSizes = async () => {
    try {
      const res = await ApiGetSizes()
      if (res?.status) {
        setSizeList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  useEffect(() => {
    getCategoryList()
    getSizes()
    getColors()
  }, [])

  return (
    <Box className='p-xl-5 px-xl-4 py-md-3 py-3'>
      <Box className='border-10 p-md-3 p-1' sx={{border:{xs:"none",md:'1px solid #ccc'}}}>
        <Typography variant='h6' className='fw-bold'>Product Overview</Typography>
        <hr className='my-1 mb-4' />
        <Grid container spacing={2} className='align-items-stretch'>
          <Grid className='border border-10 d-flex align-items-center justify-content-center' size={{ xs: 12, md: 3 }} sx={{ maxWidth:{xs:"auto",md:'250px'}, height: '250px' }}>
            <Box width={'100%'} component={'img'} src={formik.values.media[0]?.media_url}></Box>
          </Grid>
          <Grid size='grow'>
            <Box className='mb-3'>
              <Typography className='fw-bold' variant='body1' gutterBottom>Product Name</Typography>
              <Typography variant='h5'>{formik?.values?.productName}</Typography>
            </Box>
            <Box className='mb-3'>
              <Typography className='fw-bold' variant='body1' gutterBottom>Product Description</Typography>
              <Typography
                variant="body1"
                dangerouslySetInnerHTML={{ __html: formik.values.description }}
              />
            </Box>

            <Grid container spacing={2} className='mt-4'>
              <Grid size={{ xs: 6}}>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '80px' }} variant='body1'>Base Price</Typography>
                  <Typography variant='body1'>{formik.values.base_price}</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '80px' }} variant='body1'>Discount</Typography>
                  <Typography variant='body1'>{formik.values.discount_percentage}%</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '80px' }} variant='body1'>Delivery</Typography>
                  <Typography variant='body1'>{formik.values.min_delivery_days}-{formik.values.max_delivery_days} Days</Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 6}}>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '100px' }} variant='body1'>Category</Typography>
                  <Typography variant='body1'>{categoryList?.find((item) => item?.categoryId == formik.values.categoryId)?.categoryName}</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '100px' }} variant='body1'>Unit Text</Typography>
                  <Typography variant='body1'>{formik.values.unit_text}</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-4 mb-1'>
                  <Typography className='fw-bold' sx={{ minWidth: '100px' }} variant='body1'>Total Variant</Typography>
                  <Typography variant='body1'>{formik.values.variants.length}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='mt-5'>
          <Grid size={{ xs: 12 }}>
            <Typography variant='h6' className='fw-bold'>Product Images</Typography>
            <hr className='my-1 mb-4' />
          </Grid>
          {formik.values.media?.map((item: any) => (
            <Grid className='border border-10 d-flex align-items-center justify-content-center' size={{ xs: 12, md: 3 }}>
              <Box width={'100%'} component={'img'} src={item?.media_url}></Box>
            </Grid>
          ))}
        </Grid>
        <Box className='mt-5'>
          <Typography variant='h6' className='fw-bold'>Variants</Typography>
          <hr className='my-1 mb-4' />
          <TableContainer>
            <Table className='border border-10'>
              <TableHead className='bg-grey'>
                <TableRow>
                  <TableCell width={'100px'} >Image</TableCell>
                  <TableCell>Variant Name</TableCell>
                  <TableCell>Color</TableCell>
                  <TableCell className='text-center'>Size</TableCell>
                  <TableCell className='text-center'>Price (INR)</TableCell>
                  <TableCell className='text-center'>Discound (%)</TableCell>
                  <TableCell className='text-center'>Stock</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formik?.values.variants?.map((item: any) => (
                  <TableRow>
                    <TableCell width={100}>
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          mx: "auto",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          component="img"
                          src={
                            item.images?.find((img: any) => img.is_thumbnail)?.image_url ||
                            item.images?.[0]?.image_url
                          }
                          sx={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{item?.name}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            bgcolor:
                              colorlist.find(
                                (c: Color) => c.colorId === item.colorId
                              )?.hex_code,
                            border: "1px solid #ddd",
                          }}
                        />
                        <Typography variant="body2">
                          {
                            colorlist.find(
                              (c: Color) => c.colorId === item.colorId
                            )?.name
                          }
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell className='text-center'>{sizelist?.find((size: Size) => size.sizeId === item.sizeId)?.name}</TableCell>
                    <TableCell className='text-center'>{item?.price}</TableCell>
                    <TableCell className='text-center'>{item?.discount_percentage}%</TableCell>
                    <TableCell className='text-center'>{item?.stock}</TableCell>
                  </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box className='mt-5'>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card
                elevation={0}
                className='bg-transparent border p-3 border-10'
              >
                <Typography variant="h6" className="fw-bold mb-3">
                  Technical Details
                </Typography>

                <Grid
                  container
                  className='bg-grey p-2 mb-2'
                >
                  <Grid size={{ xs: 'grow' }}>Key</Grid>
                  <Grid size={{ xs: 'grow' }}>Value</Grid>
                </Grid>

                {formik.values.technicalDetails.map((item: any, index: number) => (
                  <Grid
                    container
                    spacing={1}
                    key={index}
                    className="mb-2 align-items-center border-bottom p-2"
                  >
                    <Grid size={{ xs: 'grow' }}>
                      <Typography>{item.key}</Typography>
                    </Grid>
                    <Grid size={{ xs: 'grow' }}>
                      <Typography>{item.value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </Card>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card
                elevation={0}
                className='bg-transparent border border-10 p-3'
              >
                <Typography variant="h6" className="fw-bold mb-3">
                  Wholesale Price Tiers
                </Typography>

                <Grid
                  container
                  className='bg-grey p-2 mb-2'
                >
                  <Grid size='grow'>Min Quantity</Grid>
                  <Grid size='grow'>Price (₹)</Grid>
                </Grid>

                {formik.values.wholesalePriceTiers.map(
                  (item: any, index: number) => (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="mb-2 align-items-center border-bottom p-2"
                    >
                      <Grid size={{ xs: 'grow' }}>
                        <Typography>{item.min_quantity}</Typography>
                      </Grid>
                      <Grid size={{ xs: 'grow' }}>
                        <Typography>{item.price}</Typography>
                      </Grid>
                    </Grid>
                  )
                )}
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default ProductReview
